import { Injectable } from '@angular/core';
import { AbstractSelectionService } from 'gung-list';
import { Product } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class WhiteboardSelectionService extends AbstractSelectionService<Product> {
  constructor() {
    super();
  }

  getItemId(item: Product): string {
    return item.id;
  }
}
